import { render } from "./newpri.vue?vue&type=template&id=984dbd92&scoped=true"
import script from "./newpri.vue?vue&type=script&lang=js"
export * from "./newpri.vue?vue&type=script&lang=js"

import "./newpri.vue?vue&type=style&index=0&id=984dbd92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984dbd92"]])

export default __exports__